import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../components/Converter";
import { AUFWEITUNG_NACH_DIN_SPEC_18539 } from "../../../constants";
import { useGetBohrkronenQuery } from "../../../services/API/titanApi";
import {
  selectBohrkronendurchmesser,
  setBohrkronendurchmesser,
} from "../../../store/slices/bohrkronendurchmesserSlice";
import { setVerpresskoerperdurchmesser } from "../../../store/slices/innereSlice";
import { selectTragglied } from "../../../store/slices/traggliedSlice";

function DrillBitDiameterDropDown() {
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");
  const { data: bohrkronen } = useGetBohrkronenQuery();

  const tragglied = useSelector(selectTragglied);
  const bohrkronendurchmesser = useSelector(selectBohrkronendurchmesser);

  const handleChange = (e) => {
    const bohrkronendurchmesser = Number(e.target.value);
    dispatch(setBohrkronendurchmesser(bohrkronendurchmesser));
    dispatch(
      setVerpresskoerperdurchmesser(bohrkronendurchmesser + Number(AUFWEITUNG_NACH_DIN_SPEC_18539))
    );
  };

  function findArrayElementByTitle(title) {
    return bohrkronen?.find((element) => {
      return element.tragglied_name == title;
    });
  }

  let found = false;
  function isSelectedBohrkrone(elementValue) {
    if (Number(bohrkronendurchmesser) == elementValue) {
      found = true;
      return found;
    }
    return false;
  }

  let unique_standard;
  let unique_adapter;
  function prepareOptions(bohrkronenElement) {
    let standard = [];
    let mitAdapter = [];

    // standard
    // bindiger_boden
    bohrkronenElement?.bindiger_boden?.standard?.forEach((element) => {
      standard.push(element);
    });
    // nichtbindiger_boden
    bohrkronenElement?.nichtbindiger_boden?.standard?.forEach((element) => {
      standard.push(element);
    });
    // fels
    bohrkronenElement?.fels?.standard?.forEach((element) => {
      standard.push(element);
    });

    // adapter
    // bindiger_boden
    bohrkronenElement?.bindiger_boden?.adapter?.forEach((element) => {
      mitAdapter.push(element);
    });
    // nichtbindiger_boden
    bohrkronenElement?.nichtbindiger_boden?.adapter?.forEach((element) => {
      mitAdapter.push(element);
    });
    // fels
    bohrkronenElement?.fels?.adapter?.forEach((element) => {
      mitAdapter.push(element);
    });

    unique_standard = [...new Set(new Float64Array(standard).sort())];
    unique_adapter = [...new Set(new Float64Array(mitAdapter).sort())];
  }

  function renderOptionGroup(array, indexIncrement, color) {
    return array.map((element, index) => {
      return (
        <option
          className={`${color}`}
          key={(index + indexIncrement) * 10}
          value={element}
          selected={isSelectedBohrkrone(element)}
        >
          {element}
        </option>
      );
    });
  }

  useEffect(() => {
    prepareOptions(bohrkronenElement);
  }, [bohrkronen]);

  const bohrkronenElement = findArrayElementByTitle(tragglied.title);
  prepareOptions(bohrkronenElement);

  return (
    <div>
      <select
        data-testid="select-drillbit"
        className={getClassName(bohrkronendurchmesser != 0)}
        onChange={handleChange}
      >
        <option value={0} selected={!found}>
          {t("select")}
        </option>
        <optgroup label={t("drillBits.standard")} key={1}>
          {renderOptionGroup(unique_standard, 1, "green")}
        </optgroup>
        <optgroup label={t("drillBits.withAdapter")} key={2}>
          {renderOptionGroup(unique_adapter, 2, "red")}
        </optgroup>
      </select>
    </div>
  );
}

export default DrillBitDiameterDropDown;
